<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<onboarding-container
  [displayProgressBar]="false"
  [buttonLabel]="'investment-strategy.choice.btn' | transloco"
  [specialAction]="(store.notedStrategy() ? 'investment-strategy.choice.delete' : 'investment-strategy.choice.ignore') | transloco"
  [specialActionColor]="store.notedStrategy() ? 'course-red' : 'link'"
  [formValid]="!!store.currentStrategy()"
  [error]="store.error()"
  (forward)="store.saveStrategy()"
  (specialActionClicked)="store.notedStrategy() ? modal.open(deleteModal, { centered: true }) : ignore()"
  (back)="goBack()"
>
  <p class="zero-text p-huge-med">{{ 'investment-strategy.choice.headline' | transloco }}</p>
  <p class="zero-text p-base-reg" [innerHTML]="'investment-strategy.choice.text' | transloco"></p>
  @if (store.strategies()?.length) {
    <div class="card-nav d-flex justify-content-between mt-4">
      @for (strategy of store.strategies(); track $index) {
        <div class="card" [class.active]="strategy.name === store.currentStrategy()?.name" (click)="store.setCurrentStrategy(strategy)">
          @if (strategy.isFamous) {
            <web-design-system-pill class="new-badge" type="new">{{
              'investment-strategy.choice.famous' | transloco
            }}</web-design-system-pill>
          }
          <web-design-system-icon class="text-center" [name]="'gauge-' + strategy.risk" size="large" />
          <div class="text-center zero-text p-base-med mt-2">{{ strategy.name }}</div>
          <div class="d-flex justify-content-between mt-2">
            <div>
              <div class="zero-text p-xsmall-reg label text-center">{{ 'investment-strategy.choice.return' | transloco }}</div>
              <div class="d-flex gap-half justify-content-center mt-1">
                <div class="dot filled-green"></div>
                <div class="dot" [class.filled-green]="['med', 'high'].includes(strategy.return)"></div>
                <div class="dot" [class.filled-green]="['high'].includes(strategy.return)"></div>
              </div>
            </div>
            <div>
              <div class="zero-text p-xsmall-reg label text-center">{{ 'investment-strategy.choice.risk' | transloco }}</div>
              <div class="d-flex gap-half justify-content-center mt-1">
                <div class="dot filled-red"></div>
                <div class="dot" [class.filled-red]="['med', 'high'].includes(strategy.risk)"></div>
                <div class="dot" [class.filled-red]="['high'].includes(strategy.risk)"></div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (store.currentStrategy(); as strategy) {
    <div class="mt-4 p-4 zero-surface grey-800 b-r-8">
      <div class="d-flex justify-content-center gap align-items-center">
        <web-design-system-icon name="performance-increase" size="large" />
        <div
          class="zero-text p-bigger-med"
          [class.course-green]="store.currentPerformance() > 0"
          [class.course-red]="store.currentPerformance() < 0"
        >
          @if (store.currentPerformance() > 0) {
            +
          }
          {{ store.currentPerformance() | number: '1.2-2' }} %
        </div>
      </div>
      <div class="mt-3 d-flex justify-content-center align-items-center gap-half">
        <span class="zero-text p-bigger-med">{{ 'investment-strategy.choice.performance.headline' | transloco }}</span>
        <web-design-system-icon
          name="info"
          color="dimmed"
          size="medium"
          [ngbTooltip]="'investment-strategy.choice.performance.tooltip' | transloco"
          placement="right"
        />
      </div>
      <div class="mt-3 zero-text p-base-reg label text-center">{{ 'investment-strategy.choice.performance.text' | transloco }}</div>
      <web-design-system-divider class="d-block my-3" type="light" />
      <div class="zero-text p-bigger-med">{{ 'investment-strategy.choice.details.headline' | transloco }}</div>
      <div class="row mt-3 details">
        <div class="col-12 col-md-4 mb-3 mb-md-0">
          <div class="chart-container">
            <div class="strategy zero-text p-small-med">{{ strategy.name }}</div>
            <canvas baseChart type="doughnut" [datasets]="datasets()" [options]="options" [legend]="false"></canvas>
          </div>
        </div>
        <div class="col-12 col-md-8">
          <div class="d-flex gap">
            <div class="zero-text p-small-med">{{ 'investment-strategy.choice.details.weight' | transloco }}</div>
            <div class="zero-text p-small-med">{{ 'investment-strategy.choice.details.product' | transloco }}</div>
          </div>
          <web-design-system-divider type="light" />
          @for (instrument of strategy.populatedInstruments; track instrument.isin; let i = $index) {
            <div class="d-flex gap">
              <div class="text-nowrap weight">{{ instrument.weight }} %</div>
              <div class="d-flex gap-half w-100">
                <div class="legend" [style.background]="colors[i]"></div>
                <div class="flex-grow-1">
                  <div class="zero-text p-base-reg">{{ instrument.category }}</div>
                  <div class="d-flex justify-content-between align-items-end">
                    <div class="zero-text p-small-reg label">{{ instrument.name }}</div>
                    <div class="zero-text p-small-reg link text-nowrap" (click)="showDetails(instrument)">
                      {{ 'investment-strategy.choice.details.more-info' | transloco }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <web-design-system-divider type="light" />
          }
        </div>
      </div>
    </div>

    <div class="mt-4 p-4 zero-surface grey-800 b-r-8">
      <div class="d-flex justify-content-between align-items-center">
        <span class="zero-text p-base-bold">{{ 'investment-strategy.choice.product-faq.headline' | transloco }}</span>
        <web-design-system-list-toggle (click)="displayFaq1 = !displayFaq1" [isCollapsed]="displayFaq1" />
      </div>
      @if (displayFaq1) {
        <div class="zero-text p-base-reg mt-2" [innerHTML]="strategy.faq"></div>
      }
    </div>

    <div class="mt-4 p-4 zero-surface grey-800 b-r-8">
      <div class="d-flex justify-content-between align-items-center">
        <span class="zero-text p-base-bold">{{ 'investment-strategy.choice.common-faq.headline' | transloco }}</span>
        <web-design-system-list-toggle (click)="displayFaq2 = !displayFaq2" [isCollapsed]="displayFaq2" />
      </div>
      @if (displayFaq2) {
        <div class="zero-text p-base-reg mt-2" [innerHTML]="'investment-strategy.choice.common-faq.text' | transloco"></div>
      }
    </div>
  }
</onboarding-container>
<ng-template #deleteModal let-modal>
  <web-design-system-modal (dismiss)="modal.dismiss()" [headline]="'investment-strategy.choice.delete-modal.headline' | transloco">
    <div class="zero-text p-base-reg">{{ 'investment-strategy.choice.delete-modal.text' | transloco }}</div>
    <div class="d-flex justify-content-end gap-half mt-3">
      <web-design-system-button size="small" type="secondary" (click)="modal.dismiss()">{{
        'investment-strategy.choice.delete-modal.cancel' | transloco
      }}</web-design-system-button>
      <web-design-system-button [disabled]="store.deleting()" size="small" type="red" (click)="store.deleteStrategy(); modal.dismiss()">{{
        'investment-strategy.choice.delete-modal.btn' | transloco
      }}</web-design-system-button>
    </div>
  </web-design-system-modal>
</ng-template>
